// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_PASSWORD_LABELS,
  GlobalPasswordsLabels,
} from '../../../../../../../utils/labels/globalPassword.labels';

export const PasswordRequirement = () => {
  const {
    lbl_resetPassword_requirementTips1: requirementsLbl1,
    lbl_resetPassword_requirementTips2: requirementsLbl2,
    lbl_resetPassword_requirementTips3: requirementsLbl3,
    lbl_resetPassword_requirementTips4: requirementsLbl4,
    lbl_resetPassword_requirementTips5: requirementsLbl5,
    lbl_resetPassword_requirementHeading: requirementsHeadingLbl,
  } = getLabelFromCopyOrFromTranslation(GLOBAL_PASSWORD_LABELS, GlobalPasswordsLabels);
  const passwordRequirementLabelKeys = [
    requirementsLbl1,
    requirementsLbl2,
    requirementsLbl3,
    requirementsLbl4,
    requirementsLbl5,
  ];
  return (
    <React.Fragment>
      <BodyCopy
        textAlign="center"
        fontFamily="secondary"
        fontSize="fs14"
        className="elem-mb-MED reset-password-heading"
        fontWeight="black"
      >
        {requirementsHeadingLbl}
      </BodyCopy>
      <BodyCopy
        fontFamily="secondary"
        fontSize="fs14"
        component="ul"
        className="elem-mb-MED reset-password-list"
      >
        {passwordRequirementLabelKeys.map((labelvalue) => (
          <BodyCopy component="li" textAlign="center" key={labelvalue} fontFamily="secondary">
            {labelvalue}
          </BodyCopy>
        ))}
      </BodyCopy>
    </React.Fragment>
  );
};

export default PasswordRequirement;
